(() => {
  const initializeSenixFallHero = (root) => {
    if (!root || root.dataset.senixFallInitialized === 'true') return;
    root.dataset.senixFallInitialized = 'true';
    const wraps = [...root.querySelectorAll('[data-senix-fall-hotspot-wrap]')];
    const closeAll = (exception) => wraps.forEach((wrap) => {
      if (wrap === exception) return;
      wrap.classList.remove('senix-fall-hero__hotspot-wrap--open');
      wrap.querySelector('[data-senix-fall-hotspot]')?.setAttribute('aria-expanded', 'false');
    });
    wraps.forEach((wrap) => {
      const button = wrap.querySelector('[data-senix-fall-hotspot]');
      if (!button) return;
      button.addEventListener('click', (event) => {
        event.stopPropagation();
        const willOpen = !wrap.classList.contains('senix-fall-hero__hotspot-wrap--open');
        closeAll(wrap);
        wrap.classList.toggle('senix-fall-hero__hotspot-wrap--open', willOpen);
        button.setAttribute('aria-expanded', String(willOpen));
      });
      wrap.addEventListener('mouseenter', () => button.setAttribute('aria-expanded', 'true'));
      wrap.addEventListener('mouseleave', () => {
        if (!wrap.classList.contains('senix-fall-hero__hotspot-wrap--open')) button.setAttribute('aria-expanded', 'false');
      });
    });
    document.addEventListener('click', () => closeAll());
    root.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeAll(); });
  };
  document.querySelectorAll('[data-senix-fall-hero]').forEach(initializeSenixFallHero);
  document.addEventListener('shopify:section:load', (event) => initializeSenixFallHero(event.target.querySelector('[data-senix-fall-hero]')));
})();

